import { type AvailableDates, type TimeSlot } from '@avanta/shared/types/appointments';
import { DAYTIME_HOURS } from '@avanta/shared/utils/appointments';
import { format } from 'date-fns';

const DATE_FORMAT = 'yyyy-MM-dd';
const EMOTIONAL_SUPPORT_HOURS = [21, 22, 23, 0, 1, 2, 3, 4, 5, 6, 7];

const parseHour = (time: string): number => parseInt(time.split(':')[0], 10);

const buildSlot = (hour: number, availableHours: Set<number>): TimeSlot => ({
  time: `${String(hour).padStart(2, '0')}:00`,
  disabled: !availableHours.has(hour),
});

export const getAllTimeSlotsForDate = (
  date: Date,
  availableDates: AvailableDates
): { timeSlots: TimeSlot[]; emotionalSupportSlots: TimeSlot[]; allSlots: TimeSlot[] } => {
  const availableHours = new Set((availableDates[format(date, DATE_FORMAT)] ?? []).map(parseHour));

  const timeSlots: TimeSlot[] = DAYTIME_HOURS.map(hour => buildSlot(hour, availableHours));

  const emotionalSupportSlots: TimeSlot[] = EMOTIONAL_SUPPORT_HOURS.map(hour =>
    buildSlot(hour, availableHours)
  );

  return { timeSlots, emotionalSupportSlots, allSlots: [...timeSlots, ...emotionalSupportSlots] };
};
